export default "__VITE_ASSET__CQqmyeSK__"